import React from "react";
import {
  UseFormRegister,
  Control,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import PersonalInfoFields from "./PersonalInfoFields";
import AddressFields from "./AddressFields";
import ContactInfoFields from "./ContactInfoFields";

interface CheckoutDetailsFormProps {
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  disabled?: boolean;
  addressType?: "billing" | "shipping";
}

const CheckoutDetailsForm: React.FC<CheckoutDetailsFormProps> = ({
  register,
  control,
  errors,
  setValue,
  watch,
  disabled = false,
  addressType = "billing",
}) => {
  return (
    <div className={`checkout-details-form ${disabled ? "is-disabled" : ""}`}>
      <PersonalInfoFields
        register={register}
        errors={errors}
        watch={watch}
        setValue={setValue}
        disabled={disabled}
        variant={addressType}
      />

      <AddressFields
        register={register}
        control={control}
        errors={errors}
        setValue={setValue}
        disabled={disabled}
      />

      <ContactInfoFields
        register={register}
        errors={errors}
        // Only show email if this is the billing address
        showEmail={addressType === "billing"}
        disabled={disabled}
      />
    </div>
  );
};

export default CheckoutDetailsForm;
